import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import Link from 'common/Link';
import { P } from 'common/ui/Text';
import { canStartCoreTrial, canStartProTrial } from 'common/util/canStartTrial';
import isFree from 'common/util/isFree';
import styles from 'css-module/components/subdomain/admin/v2/AdminV2Notices/_AdminV2TrackedUserNotice.module.scss';

export default function AdminV2TrackedUserNotice() {
  const company = useContext(CompanyContext);
  if (!company?.viewerIsMember) {
    return null;
  } else if (!isFree(company.billingData?.plan?.planID)) {
    return null;
  } else if (!company.limits?.users) {
    return null;
  }

  const limit = company.limits?.users;
  const trackedUsers = company.contributorCount;
  const canStartTrial =
    canStartCoreTrial(company.billingData?.plan?.planID, company.planTrial?.planID) ||
    canStartProTrial(company.billingData?.plan?.planID, company.planTrial?.planID);

  if (trackedUsers < limit / 2) {
    return null;
  } else if (trackedUsers < limit) {
    // you're getting close to the limit
    return (
      <div className={styles.adminV2TrackedUserNotice}>
        <P>
          You're at {trackedUsers} of your {limit} tracked user limit
        </P>
        <Link className={styles.action} to="/admin/settings/billing/subscription">
          {canStartTrial ? 'Start trial' : 'Upgrade'}
        </Link>
      </div>
    );
  } else if (trackedUsers >= limit) {
    // you've hit the limit
    return (
      <div className={styles.adminV2TrackedUserNotice}>
        <P>You've hit the {limit} tracked user limit</P>
        <Link className={styles.action} to="/admin/settings/billing/subscription">
          {canStartTrial ? 'Start trial' : 'Upgrade'}
        </Link>
      </div>
    );
  } else {
    // should never get here, but makes ts happy
    return null;
  }
}
